<template>
	<tbody>
		<tr v-if="this.product" class="link" @click="showDetails = !showDetails" :class="showDetails ? 'expanded' : ''">
			<td>{{ rowIndex }} </td>
			<td>{{ product.productId }}</td>
			<td>{{ product.artnr }}</td>
			<td>
				<Button v-if="isLoggedIn && this.debug" label="KÖP" @click.stop="buy()" />
				{{ product.name }}
			</td>
			<td>
				{{ product.manufactorName }}
			</td>
			<td>
				{{ product.score }}
			</td>
			<td>
				{{ this.formatPrice(this.product) }}
			</td>
			<td>
				<ProductRowImage v-if="product.image" :fileName="product.image" />
			</td>
			<td>
				<ProductRowImage v-if="product.startImage" :fileName="product.startImage" />
			</td>

			<td>
				{{ this.product.itemCount }}
			</td>
			<td>
				<Button label=">" @click.stop="showProductDetails();" />
			</td>



		</tr>
		<tr v-if="showDetails && this.product">
			<td style="background:var(--bg-debug);"></td>
			<td colspan="10" style="background:var(--bg-debug);color:white;">
				<pre>{{ product }}</pre>
			</td>
		</tr>
		<tr v-if="!this.product">
			<td colspan="10">ProductId: {{ this.productId }}</td>
		</tr>
	</tbody>
</template>

<script>
import formatHelper from '../../helper/format-helper';
import { userMixin } from '../../mixins/userMixin';
import { productMixin } from '../../mixins/productMixin';
import { USER_STORE_ACTION } from '../../store/user-store';
import ProductRowImage from './ProductRowImage.vue';


export default {
	name: "ProductRow",
	components: { ProductRowImage },
	mixins: [userMixin, productMixin],
	data() {
		return {
			showDetails: false
		};
	},
	props: {
		productId: Number,
		rowIndex: Number
	},
	computed: {

		product() {

			const product = this.$store.state.productStore.data.productList[this.productId]
			if (product){
				product.urlKey = formatHelper.urlProductKey(product.name);
			}

			return product;

		},



	},
	methods: {
		showProductDetails(){

			this.$router.push('/product/' + this.productId + "/" + this.product.urlKey)

		},
		test() {
			this.showDetails = true
		},
		buy() {

			var data = { currentOrderId: this.currentOrderId, post: { productId: this.productId, quantity: 1 } }
			this.$store.dispatch({ type: USER_STORE_ACTION.ADD_PRODUCT_TO_ORDER, data: data });
		}

	}
};
</script>

<style scoped></style>